export default function (cb) { // eslint-disable-line func-names
  if ('complete' !== document.readyState &&
    'interactive' !== document.readyState) {
    document.addEventListener('DOMContentLoaded', cb);
  } else {
    cb();
  }
}
